import React, { useState, useEffect } from "react";
import { Rotate as Hamburger } from "hamburger-react";
import Headroom from "react-headroom";
import Nav from "../nav/nav";
import LocaleSwitcher from "./locale-switcher"
import Logo from "./../../assets/images/logos/flaunt-logo-white.svg";
import LogoMobile from "./../../assets/images/logos/flaunt-icon-white.svg";

const Header = ({ location, podcastHead }) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        if (window.scrollY === 0) {
          enableHeadroomPointerEvents();
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);
  
  const enableHeadroomPointerEvents = () => {
    document.querySelector(".headroom-wrapper")?.classList.remove("headroom-wrapper-no-clicks");
    document.querySelector(".report-sidebar-container-content")?.classList.add("lowered-sidebar");
  }

  const disableHeadroomPointerEvents = () => {
    document.querySelector(".headroom-wrapper")?.classList.add("headroom-wrapper-no-clicks");
    document.querySelector(".report-sidebar-container-content")?.classList.remove("lowered-sidebar");
  }

  const handleNavClose = () => {
    if(isOpen) {
      setOpen(false);
    }
  }

  return (
    <Headroom
      disable={isOpen}
      onPin={ enableHeadroomPointerEvents }
      onUnpin={ disableHeadroomPointerEvents }
      wrapperStyle={{zIndex: 10000}}
    >
      <header className={podcastHead ? "header header-pod" : "header header-default"} >
        <div 
          className={isOpen ? "header-top-bar active" : "header-top-bar"}
        >
          <LocaleSwitcher
            location={location}
          />
          <div className="header-logo">
            <a
              href={!isOpen ? "/" : ""}
              alt='Flaunt Digital'
              >
              <picture>
                <source media="(min-width: 600px)" srcSet={ Logo } />
                <img alt="Flaunt Digital" onClick={ handleNavClose } src={ LogoMobile } className="header-top-bar-logo" />
              </picture>
            </a>
          </div>
          <span className="hamburger-wrapper">
            <Hamburger  
              toggled={ isOpen } 
              className="header-top-bar-hamburger" 
              toggle={setOpen} 
              easing="ease-in-out"
              label="menu"
            />
          </span>
        </div>
        <Nav isOpen={ isOpen } setOpen={ setOpen } location={ location } />
      </header>
    </Headroom>
  )
}

export default Header;